import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import { MyApi } from "../../MyApi";
import banner from "../../assets/images/baenner.png";
import { Link } from "react-router-dom";
export default function About() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        setLoading(true);
        setError(false);

        const res = await axios.get(
          MyApi.BASE_URL + MyApi.Home_About,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status && res.data.data) {
          setData(res.data.data);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("API Error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchAbout();
  }, []);

  if (loading) return <p className="text-center py-5">Loading...</p>;
  if (error) return <p className="text-center py-5">Something went wrong</p>;

  return (
    <div className="py-4 abouthome"> 
      <Container>
      <Link to="/booking"><img src={banner} alt="" className="img-fluid rounded-3 mb-4"/></Link>
        <h1>{data?.pagename}</h1>
        {/* 🔥 HTML content from API */}
        <div
          dangerouslySetInnerHTML={{
            __html: data?.pagecontent,
          }}
        />
      </Container>
    </div>
  );
}